export default {
    add_playlist: "Add to playlist",
    audio_save_error: "There was an error saving the audio",
    audio_save_success: "Audio saved successfully",
    audios: "Audios",
    delete_playlist: "Delete Playlist",
    duration: "Duration",
    episode: "Episode",
    episode_plural: "Episodes",
    favorite_podcast: "Favorite Podcast",
    how_do_you_rate_this_podcast: "How do you rate this podcast?",
    like_podcast: "Like Podcast",
    listened: "Listened",
    listening: "Listening",
    loading_podcasts: "Loading podcasts",
    new_playlist: "New Playlist",
    new_podcast: "New podcast",
    no_audios_on_podcast: "There are no audios on the podcast",
    no_podcasts_are_available_at_the_moment: "No podcasts are currently available",
    no_podcasts_are_available_with_the_selected_filter: "There are no podcasts available for the selected filter",
    no_podcasts_found: "No podcast was found",
    no_podcasts_found_with_this_filter: "No podcast was found with this filter",
    only_available_when_finished_podcast: "Available only after completing the podcast",
    play_sound: "Play",
    playlist: "Playlist",
    playlist_save_success: "Playlist saved successfully",
    playlists: "Playlists",
    podcast: "Podcast",
    podcast_report: "Podcasts report",
    podcasts: "Podcasts",
    there_are_no_podcasts_avaliable_at_the_moment: "There are no podcasts avaliable at the moment",
    to_listen: "To Listen",
    unexpected_error_try_again_later: "Unexpected error, please try again later",
    unfavorite_podcast: "Unfavorite Podcast",
    unlike_podcast: "Unlike Podcast"
}
